import { render, staticRenderFns } from "./rename-group.vue?vue&type=template&id=b25c1ae0&scoped=true&"
import script from "./rename-group.vue?vue&type=script&lang=js&"
export * from "./rename-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25c1ae0",
  null
  
)

export default component.exports